var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeetingSyncingIcon = function SvgMeetingSyncingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F7370",
    fillOpacity: 0.89,
    d: "M13.374 35.473q.436 0 .84.017c.367.016.546.44.384.78q-.191.403-.317.827a5.8 5.8 0 0 0-.235 1.658v1.238c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.275c-.131.069-.303.069-.646.069H8.98c-.343 0-.515 0-.646-.069a.62.62 0 0 1-.267-.275C8 40.522 8 40.346 8 39.993v-1.169q0-1.485 1.478-2.418t3.896-.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillOpacity: 0.55,
    d: "M13.374 35.473q.436 0 .84.017c.367.016.546.44.384.78q-.191.403-.317.827a5.8 5.8 0 0 0-.235 1.658v1.238c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.275c-.131.069-.303.069-.646.069H8.98c-.343 0-.515 0-.646-.069a.62.62 0 0 1-.267-.275C8 40.522 8 40.346 8 39.993v-1.169q0-1.485 1.478-2.418t3.896-.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillOpacity: 0.55,
    d: "M13.374 35.473q.436 0 .84.017c.367.016.546.44.384.78q-.191.403-.317.827a5.8 5.8 0 0 0-.235 1.658v1.238c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.275c-.131.069-.303.069-.646.069H8.98c-.343 0-.515 0-.646-.069a.62.62 0 0 1-.267-.275C8 40.522 8 40.346 8 39.993v-1.169q0-1.485 1.478-2.418t3.896-.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F7370",
    fillOpacity: 0.89,
    d: "M22.898 33.326q1.78 0 3.275.346 1.494.345 2.57 1.036 1.075.69 1.645 1.606.57.915.571 2.021v1.238c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.276c-.131.068-.302.068-.645.068H15.816c-.343 0-.514 0-.645-.068a.62.62 0 0 1-.268-.276c-.066-.134-.066-.31-.066-.663v-1.238q0-1.105.588-2.02.587-.915 1.662-1.607 1.075-.69 2.57-1.036 1.494-.345 3.241-.346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillOpacity: 0.55,
    d: "M22.898 33.326q1.78 0 3.275.346 1.494.345 2.57 1.036 1.075.69 1.645 1.606.57.915.571 2.021v1.238c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.276c-.131.068-.302.068-.645.068H15.816c-.343 0-.514 0-.645-.068a.62.62 0 0 1-.268-.276c-.066-.134-.066-.31-.066-.663v-1.238q0-1.105.588-2.02.587-.915 1.662-1.607 1.075-.69 2.57-1.036 1.494-.345 3.241-.346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.55,
    d: "M22.898 33.326q1.78 0 3.275.346 1.494.345 2.57 1.036 1.075.69 1.645 1.606.57.915.571 2.021v1.238c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.276c-.131.068-.302.068-.645.068H15.816c-.343 0-.514 0-.645-.068a.62.62 0 0 1-.268-.276c-.066-.134-.066-.31-.066-.663v-1.238q0-1.105.588-2.02.587-.915 1.662-1.607 1.075-.69 2.57-1.036 1.494-.345 3.241-.346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F7370",
    fillOpacity: 0.89,
    d: "M32.626 35.473q2.418 0 3.896.916Q38 37.304 38 38.824v1.169c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.275c-.131.069-.303.069-.646.069h-4.086c-.343 0-.515 0-.646-.069a.62.62 0 0 1-.267-.275c-.067-.134-.067-.31-.067-.663v-1.238q0-.898-.218-1.693a5.6 5.6 0 0 0-.288-.8c-.151-.338.027-.755.389-.772a18 18 0 0 1 .789-.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillOpacity: 0.55,
    d: "M32.626 35.473q2.418 0 3.896.916Q38 37.304 38 38.824v1.169c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.275c-.131.069-.303.069-.646.069h-4.086c-.343 0-.515 0-.646-.069a.62.62 0 0 1-.267-.275c-.067-.134-.067-.31-.067-.663v-1.238q0-.898-.218-1.693a5.6 5.6 0 0 0-.288-.8c-.151-.338.027-.755.389-.772a18 18 0 0 1 .789-.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillOpacity: 0.55,
    d: "M32.626 35.473q2.418 0 3.896.916Q38 37.304 38 38.824v1.169c0 .352 0 .529-.067.663a.62.62 0 0 1-.267.275c-.131.069-.303.069-.646.069h-4.086c-.343 0-.515 0-.646-.069a.62.62 0 0 1-.267-.275c-.067-.134-.067-.31-.067-.663v-1.238q0-.898-.218-1.693a5.6 5.6 0 0 0-.288-.8c-.151-.338.027-.755.389-.772a18 18 0 0 1 .789-.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F7370",
    fillOpacity: 0.89,
    d: "M13.374 28.565q1.143 0 1.915.794.772.795.772 1.97 0 1.14-.772 1.95-.772.813-1.915.813-1.108 0-1.898-.812a2.7 2.7 0 0 1-.789-1.952q0-1.174.79-1.969a2.58 2.58 0 0 1 1.897-.794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillOpacity: 0.55,
    d: "M13.374 28.565q1.143 0 1.915.794.772.795.772 1.97 0 1.14-.772 1.95-.772.813-1.915.813-1.108 0-1.898-.812a2.7 2.7 0 0 1-.789-1.952q0-1.174.79-1.969a2.58 2.58 0 0 1 1.897-.794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillOpacity: 0.55,
    d: "M13.374 28.565q1.143 0 1.915.794.772.795.772 1.97 0 1.14-.772 1.95-.772.813-1.915.813-1.108 0-1.898-.812a2.7 2.7 0 0 1-.789-1.952q0-1.174.79-1.969a2.58 2.58 0 0 1 1.897-.794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F7370",
    fillOpacity: 0.89,
    d: "M32.626 28.565q1.142 0 1.914.794.773.795.773 1.97 0 1.14-.773 1.95-.773.813-1.914.813-1.109 0-1.898-.812a2.7 2.7 0 0 1-.79-1.952q0-1.174.79-1.969a2.58 2.58 0 0 1 1.898-.794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillOpacity: 0.55,
    d: "M32.626 28.565q1.142 0 1.914.794.773.795.773 1.97 0 1.14-.773 1.95-.773.813-1.914.813-1.109 0-1.898-.812a2.7 2.7 0 0 1-.79-1.952q0-1.174.79-1.969a2.58 2.58 0 0 1 1.898-.794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillOpacity: 0.55,
    d: "M32.626 28.565q1.142 0 1.914.794.773.795.773 1.97 0 1.14-.773 1.95-.773.813-1.914.813-1.109 0-1.898-.812a2.7 2.7 0 0 1-.79-1.952q0-1.174.79-1.969a2.58 2.58 0 0 1 1.898-.794"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F7370",
    fillOpacity: 0.89,
    d: "M22.898 24q1.714 0 2.872 1.192t1.159 2.953q0 1.727-1.16 2.936-1.158 1.21-2.871 1.21-1.68 0-2.855-1.21t-1.176-2.936q0-1.761 1.176-2.953T22.898 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    fillOpacity: 0.55,
    d: "M22.898 24q1.714 0 2.872 1.192t1.159 2.953q0 1.727-1.16 2.936-1.158 1.21-2.871 1.21-1.68 0-2.855-1.21t-1.176-2.936q0-1.761 1.176-2.953T22.898 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    fillOpacity: 0.55,
    d: "M22.898 24q1.714 0 2.872 1.192t1.159 2.953q0 1.727-1.16 2.936-1.158 1.21-2.871 1.21-1.68 0-2.855-1.21t-1.176-2.936q0-1.761 1.176-2.953T22.898 24"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#n)",
    strokeWidth: 0.234,
    d: "M13.374 35.59q.435 0 .835.017a.33.33 0 0 1 .29.2.5.5 0 0 1-.006.412 5.8 5.8 0 0 0-.564 2.536v1.237c0 .178 0 .305-.008.405a.6.6 0 0 1-.046.208.5.5 0 0 1-.218.223.5.5 0 0 1-.198.047c-.096.008-.22.008-.393.008H8.98c-.173 0-.296 0-.392-.008a.5.5 0 0 1-.198-.047.5.5 0 0 1-.218-.224.6.6 0 0 1-.046-.207c-.008-.1-.008-.227-.008-.405v-1.168c0-.942.465-1.714 1.423-2.32.96-.605 2.236-.914 3.834-.914Zm19.252 0c1.599 0 2.874.303 3.835.898.956.593 1.422 1.37 1.422 2.336v1.168c0 .178 0 .305-.008.405a.6.6 0 0 1-.046.208.5.5 0 0 1-.218.223.5.5 0 0 1-.198.047c-.096.008-.22.008-.392.008h-4.087c-.174 0-.297 0-.393-.008a.5.5 0 0 1-.198-.047.5.5 0 0 1-.218-.224.6.6 0 0 1-.046-.207c-.008-.1-.008-.227-.008-.405v-1.237a6.5 6.5 0 0 0-.222-1.724 6 6 0 0 0-.294-.817.5.5 0 0 1 0-.408.33.33 0 0 1 .287-.199 18 18 0 0 1 .784-.017Zm-9.728-2.147q1.77 0 3.249.343 1.478.343 2.533 1.02 1.055.68 1.61 1.57.552.886.553 1.959v1.238c0 .178-.001.305-.009.404a.6.6 0 0 1-.046.208.5.5 0 0 1-.218.223.5.5 0 0 1-.198.047c-.096.008-.22.009-.392.009H15.816c-.173 0-.296 0-.392-.009a.5.5 0 0 1-.198-.047.5.5 0 0 1-.218-.223.6.6 0 0 1-.046-.208 6 6 0 0 1-.009-.404v-1.238q0-1.072.57-1.958.57-.89 1.627-1.57 1.055-.679 2.533-1.02 1.48-.344 3.215-.344Zm-9.524-4.761q1.094 0 1.831.758.739.759.74 1.888 0 1.094-.74 1.871-.738.777-1.831.776c-.707 0-1.309-.258-1.814-.777a2.58 2.58 0 0 1-.756-1.87c0-.754.252-1.38.756-1.887a2.46 2.46 0 0 1 1.814-.76Zm19.252 0q1.094 0 1.831.758.739.759.74 1.888 0 1.094-.74 1.871-.738.777-1.831.776-1.06 0-1.814-.777a2.58 2.58 0 0 1-.756-1.87q0-1.128.755-1.887a2.46 2.46 0 0 1 1.815-.76Zm-9.728-4.565q1.666 0 2.788 1.156 1.125 1.156 1.125 2.872 0 1.683-1.125 2.856-1.123 1.173-2.788 1.173-1.63.001-2.771-1.174t-1.143-2.855q0-1.716 1.142-2.872 1.142-1.157 2.772-1.156Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.19691 10.2624 -82.146 -26.4443 40.248 22.062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7962",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.97431 3.87153 -33.7246 15.7452 11.082 23.992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.19691 10.2624 -82.146 -26.4443 40.248 22.062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7962",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.97431 3.87153 -33.7246 15.7452 11.082 23.992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.19691 10.2624 -82.146 -26.4443 40.248 22.062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7962",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.97431 3.87153 -33.7246 15.7452 11.082 23.992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.19691 10.2624 -82.146 -26.4443 40.248 22.062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7962",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.97431 3.87153 -33.7246 15.7452 11.082 23.992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.19691 10.2624 -82.146 -26.4443 40.248 22.062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7962",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.97431 3.87153 -33.7246 15.7452 11.082 23.992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.19691 10.2624 -82.146 -26.4443 40.248 22.062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7962",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.97431 3.87153 -33.7246 15.7452 11.082 23.992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7962",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 31.469,
    x2: 14.715,
    y1: 37.642,
    y2: 25.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 30.934,
    height: 17.701,
    x: 8,
    y: 24,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.934,
    dy: 0.701
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.467
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5285_6396"
  })))));
};
export default SvgMeetingSyncingIcon;